export const REIMBURSEMENT_REPORT_INITIAL_LOADING =
  'REIMBURSEMENT_REPORT_INITIAL_LOADING';
export const REIMBURSEMENT_REPORT_GET_REIMBURSEMENT_RATES =
  'REIMBURSEMENT_REPORT_GET_REIMBURSEMENT_RATES';
export const REIMBURSEMENT_REPORT_GET_ALL_SITES =
  'REIMBURSEMENT_REPORT_GET_ALL_SITES';

export const REIMBURSEMENT_REPORT_UPDATE_SELECTED_SITES =
  'REIMBURSEMENT_REPORT_UPDATE_SELECTED_SITES';
export const REIMBURSEMENT_REPORT_SELECT_ALL_SITES =
  'REIMBURSEMENT_REPORT_SELECT_ALL_SITES';

export const REIMBURSEMENT_REPORT_GET_REPORT =
  'REIMBURSEMENT_REPORT_GET_REPORT';
export const REIMBURSEMENT_REPORT_CLEAR_REPORT =
  'REIMBURSEMENT_REPORT_CLEAR_REPORT';
export const REIMBURSEMENT_REPORT_LOADING = 'REIMBURSEMENT_REPORT_LOADING';

export const REIMBURSEMENT_REPORT_ERROR = 'REIMBURSEMENT_REPORT_ERROR';



// WEBPACK FOOTER //
// ./src/pages/reimbursement/state/report/types.js